import React, { FC } from "react";

import { FormBuilderList } from "@components/main/forms";

const FormBuilderPage: FC = () => <FormBuilderList />;

export default FormBuilderPage;
